import React from 'react';
import Icon from '@src/v3/components/coreUI/icon';
import Button from '../button';

const ZoomControls = ({
  onPlusClick,
  onMinusClick,
}: {
  onPlusClick: () => void;
  onMinusClick: () => void;
}) => {
  return (
    <div className="m-3 inline-flex h-[45px] px-3 py-4 justify-center items-center gap-x-2 shrink-0 !rounded-full border border-[#E5E7EB] bg-[linear-gradient(180deg,#EDEDED_0%,#FFF_100%)] shadow-md">
      <Button
        variant="ghost"
        className="w-5 h-5 cursor-pointer font-medium text-[#1E1E1E] transition-colors"
        onClick={onPlusClick}
      >
        <Icon iconName="plus" />
      </Button>
      <Button
        variant="ghost"
        className="w-5 h-5 cursor-pointer font-medium text-[#1E1E1E] transition-colors"
        onClick={onMinusClick}
      >
        <Icon iconName="minus" />
      </Button>
    </div>
  );
};

export default ZoomControls;
